<template>
  <video
    src="/Phairify_Recruiter.mp4"
    poster="/Video_Recruiter_Screenshot.png"
    @mouseenter="showControls = true"
    @mouseleave="showControls = false"
    :controls="showControls"
    :autoplay="autoPlay"
    :muted="autoPlay"
  />
</template>

<script>
export default {
  name: 'PrePaywallRecruiterVideo',
  props: {
    autoPlay: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      showControls: false,
    };
  },
};
</script>

<style scoped>
video {
  width: 100%;
}
</style>
